import { render, staticRenderFns } from "./asiatech.vue?vue&type=template&id=092c1a30&"
import script from "./asiatech.vue?vue&type=script&lang=js&"
export * from "./asiatech.vue?vue&type=script&lang=js&"
import style0 from "./asiatech.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports